<template>
    <div style="background-color: #eeeeee;padding-bottom: 60px;">
        <img style="display: block;margin: 0 auto;" src="../../assets/banner12.png" alt="">
        <div class="main" style="padding-bottom: 40px;">
            <ul class="Breadcrumb">
                <li @click="backPage('/home')">首页</li>
                <li>></li>
                <li>加入士模</li>
            </ul>
            <div class="joinUs">
                <div class="fleft">
                    <p>社会招聘</p>
                    <span @click="check(1, '社会招聘')" style="background-color: #268dcf;">查看职位</span>
                </div>
                <div class="fleft">
                    <p>校园招聘</p>
                    <span @click="check(2, '校园招聘')" style="background-color: #cf6a26;">查看职位</span>
                </div>
            </div>
        </div>
        <div style="background-color: #fff;padding: 30px 0;">
            <div style="width:900px;margin:0 auto;">
                <p style="font-size:16px;line-height: 36px;color: #222222;">
                    在士模，我们有业内知名专家带领团队，工作中强调专注高效、结果导向，打造让每个人都能茁壮成长的平台。我们将优秀的伙伴视为最大的财富，欢迎追求创新和接受挑战的伙伴加入士模微电子，实现与公司共同成长、相互成就。
                </p>

            </div>
            <div style="width:1050px;margin:0 auto;">
                <div class="top" style="padding:0 160px">
                    <div>
                        <img src="../../assets/icon16.png" alt="">
                        <p>大咖带领的</p>
                        <span>高效团队</span>
                        <i>行业知名专家带领团队；<br />扁平化管理。</i>
                    </div>
                    <div>
                        <img src="../../assets/icon17.png" alt="">
                        <p>行业领先的</p>
                        <span>研发成果</span>
                        <i>知识产权自主可控；<br />
                            原创性技术成果国际排名前列。</i>
                    </div>
                </div>
                <div class="top">
                    <div>
                        <img src="../../assets/icon18.png" alt="">
                        <p>创新驱动的</p>
                        <span>学习平台</span>
                        <i>前沿技术交流；<br />
                            特色化培训平台。</i>
                    </div>
                    <div>
                        <img src="../../assets/icon19.png" alt="">
                        <p>丰富多彩的</p>
                        <span>团建活动</span>
                        <i
                            style="text-align: left;padding: 0 30px;">年会、春游、飞盘、冰壶等时下最新潮的活动，让我们了解工作以外你们的才能，你想到的我们有，你没想到的我们也有……</i>
                    </div>
                    <div>
                        <img src="../../assets/icon20.png" alt="">
                        <p>务实平等的</p>
                        <span>工作环境</span>
                        <i>开放式办公环境，团队合作更加高效；<br />
                            弹性工作，时间自主掌控。</i>
                    </div>
                </div>
            </div>
        </div>
        <div class="main" style="padding-top:60px">
            <img src="../../assets/banner13.png" alt="">
        </div>
    </div>
</template>
<script>
import {backPage} from '@/utils/common'

export default {
    methods: {
        check(id, type) {
            this.$router.push({ path: "/recruit", query: { id: id, type: type } })
            document.documentElement.scrollTop = 0;
        },
        backPage,

    }
}
</script>
<style scoped lang="scss">
.joinUs {
    height: 320px;
    background: url('../../assets/img27.png');
    overflow: hidden;
    padding: 90px 0;
    box-sizing: border-box;

    .fleft {
        width: 50%;
        text-align: center;
        color: #fff;

        >* {
            display: block;
        }

        p {
            font-size: 24px;
            font-weight: bold;
        }

        span {
            width: 100px;
            height: 36px;
            line-height:36px;
            font-size: 16px;
            font-family: 'MicrosoftYaHeiLight';
            margin: 20px auto;
            cursor: pointer;
        }

    }
}

.top {
    display: flex;

    >div {
        flex: 1;
        text-align: center;
        display: block;
        margin-bottom: 10px;

        img {
            display: block;
            margin: 20px auto;
        }

        p {
            font-size: 18px;
            color: #103f73;
            font-family: 'MicrosoftYaHeiLight';
        }

        span {
            font-size: 24px;
            color: #103f73;
            font-weight: bold;
            display: block;
            margin-bottom: 12px;
        }

        i {
            color: #222222;
            font-size: 14px;
            display: block;
            font-style: normal;
            line-height: 22px;
        }
    }
}</style>


// WEBPACK FOOTER //
// src/views/about/joinUs.vue